import { CssVarSvg } from "@/components/CssVarElements"; // The hopscotch court — the place you're being let into. Ported from the
// design's WelcomeCourt (welcome.jsx). Originally lived only in SignUpPage
// (HOP-33); extracted so the Create Learner modal's first-run state
// (HOP-36) can share it instead of duplicating the SVG.
export function WelcomeCourt({ maxWidth = 470 }: {maxWidth?: number;}) {
  const STEP = 96;
  const S = 92;
  const squares = [
  { n: 6, x: 96, y: 0 },
  { n: 5, x: 0, y: 0 },
  { n: 4, x: 48, y: STEP },
  { n: 3, x: 96, y: STEP * 2 },
  { n: 2, x: 0, y: STEP * 2 },
  { n: 1, x: 48, y: STEP * 3, start: true }];

  const rays = Array.from({ length: 8 }, (_, i) => {
    const a = i / 8 * Math.PI * 2;
    const r0 = 36,r1 = 47,cx = 94,cy = -72;
    return { x1: cx + Math.cos(a) * r0, y1: cy + Math.sin(a) * r0, x2: cx + Math.cos(a) * r1, y2: cy + Math.sin(a) * r1 };
  });
  return (
    <CssVarSvg viewBox="-66 -128 320 600" cssVars={{ width: '100%', maxWidth, height: 'auto', display: 'block', overflow: 'visible' }} aria-hidden="true">
      <ellipse cx="94" cy="396" rx="116" ry="15" fill="rgba(27,26,64,0.10)" />
      <g>
        {rays.map((r, i) =>
        <line key={i} x1={r.x1} y1={r.y1} x2={r.x2} y2={r.y2} stroke="var(--ink)" strokeWidth="2.4" strokeLinecap="round" />
        )}
        <circle cx="96" cy="-70" r="34" fill="var(--yellow)" stroke="var(--ink)" strokeWidth="1.5" />
        <circle cx="94" cy="-72" r="34" fill="var(--yellow)" stroke="var(--ink)" strokeWidth="1.5" />
      </g>
      <path d="M142 4 C 138 -16, 112 -26, 96 -38" fill="none" stroke="var(--ink)" strokeWidth="2" strokeLinecap="round" strokeDasharray="1.5 8" opacity="0.45" />
      <g transform="rotate(-1.2 94 192)">
        {squares.map((sq) =>
        <g key={sq.n}>
            <rect x={sq.x + 3.5} y={sq.y + 3.5} width={S} height={S} rx="7" fill={sq.start ? 'rgba(251,77,61,0.30)' : 'rgba(27,26,64,0.10)'} />
            <rect x={sq.x} y={sq.y} width={S} height={S} rx="7" fill={sq.start ? 'var(--coral)' : 'var(--paper-2)'} stroke="var(--ink)" strokeWidth="1.5" />
            {!sq.start &&
          <text x={sq.x + S / 2} y={sq.y + S / 2 + 13} textAnchor="middle" fontFamily="var(--f-display)" fontWeight="800" fontSize="38" fill="var(--ink)" opacity="0.85">
                {sq.n}
              </text>
          }
          </g>
        )}
      </g>
      <g transform="rotate(-9 96 336)">
        <ellipse cx="96" cy="336" rx="34" ry="22" fill="var(--ink)" />
        <ellipse cx="96" cy="336" rx="26" ry="15" fill="none" stroke="var(--yellow)" strokeWidth="1.6" strokeDasharray="2 4.5" />
      </g>
      <text x="182" y="312" fontFamily="var(--f-caveat)" fontWeight="700" fontSize="25" fill="var(--ink)" opacity="0.72" transform="rotate(-5 182 312)">start here</text>
      <path d="M180 320 C 158 332, 142 336, 124 336" fill="none" stroke="var(--coral)" strokeWidth="2.4" strokeLinecap="round" />
      <path d="M131 329 L 122 336 L 132 341" fill="none" stroke="var(--coral)" strokeWidth="2.4" strokeLinecap="round" strokeLinejoin="round" />
    </CssVarSvg>);

}